import React from 'react';
import { Img, Picture, Source } from '@xo-union/tk-component-picture';

interface ThumbnailRendererProps {
  mediaApiId: string;
  slug: string;
  width?: number;
  height?: number;
  sources: Array<{ viewport: string; width?: number; height?: number }>;
  className?: string;
  reactKey?: string;
}

const BaseThumbnail: React.FC<ThumbnailRendererProps> = ({
  mediaApiId,
  width,
  height,
  sources,
  slug,
  className,
  reactKey,
}) => {
  return (
    <Picture id={mediaApiId} slug={slug} key={reactKey} lazy>
      {sources.map(source => (
        <Source key={source.viewport} viewport={source.viewport} width={source.width} height={source.height} />
      ))}
      <Img className={className} width={width} height={height} />
    </Picture>
  );
};

export const ThumbnailRenderer: React.FC<ThumbnailRendererProps> = ({
  mediaApiId,
  width,
  height,
  sources,
  slug,
  className,
  reactKey,
}) => {
  if (!mediaApiId) {
    return <div />;
  }
  return (
    <BaseThumbnail
      mediaApiId={mediaApiId}
      width={width}
      height={height}
      sources={sources}
      slug={slug}
      className={className}
      reactKey={reactKey}
    />
  );
};
